export class CostDataFilters {
    'accountId';
    'sourceAccountProviderId';
    'projectId';
    'cloudProvider';
    'resourceType';
    'resourceId';
    'tagKeys';
    'tagKeyValues';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "accountId",
            "baseName": "accountId",
            "type": "CloudAccountIdFilters",
            "format": ""
        },
        {
            "name": "sourceAccountProviderId",
            "baseName": "sourceAccountProviderId",
            "type": "SourceAccountProviderIdFilters",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "ProjectIdFilters",
            "format": ""
        },
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "CloudProviderFilters",
            "format": ""
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "ResourceTypeFilters",
            "format": ""
        },
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "IdFilters",
            "format": ""
        },
        {
            "name": "tagKeys",
            "baseName": "tagKeys",
            "type": "TagKeysFilters",
            "format": ""
        },
        {
            "name": "tagKeyValues",
            "baseName": "tagKeyValues",
            "type": "TagKeyValuesFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CostDataFilters.attributeTypeMap;
    }
    constructor() {
    }
}
